import React from "react";

function Icons({ name }) {
  return (
    <div
      style={{
        width: 50,
        height: 40,
        border: "1px solid 	#dcdcdc",
        borderRadius: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <i className={name} style={{ fontSize: 25, color: "grey" }}></i>
    </div>
  );
}

export default Icons;
